import React, { useState } from 'react'
import styled from 'styled-components'
import { getComma } from '../../utils/getComma'
import colors from '../../styles/colors'

const MoDetailItem = ({
  orderList,
  hiddenOrder,
  isPickup,
  setOrderHistoryItem,
  isComplete,
}) => {
  const orderCancelled = orderList.OrderStatus === 307 //주문취소
  const orderTypeDelivery = orderList.orderType === 'D' // 배달유무(배달정보)

  const [isDeliveryVisible, setIsDeliveryVisible] = useState(false)

  const handleToggleDelivery = (item, flag) => {
    setIsDeliveryVisible(!isDeliveryVisible)
    setOrderHistoryItem(item, flag)
  }

  return (
    <>
      <MoDetailWrap>
        <MoDetailBoxTit>주문정보</MoDetailBoxTit>
        <MoDetailBox orderCancelled={orderCancelled}>
          {JSON.parse(orderList?.orderGoodsList).map((orderGoods, i) => {
            return (
              <>
                {/* <MoDetailBtwBox>
                  <MoDetailTxt>{orderGoods.goodsName}</MoDetailTxt>
                  <MoDetailPrice>
                    {getComma(orderGoods.salePrice)}원
                  </MoDetailPrice>
                </MoDetailBtwBox> */}
                <MoDetailBtwBox>
                  <MoDetailTxt>{`${orderGoods?.goodsName ?? ''}${
                    orderGoods.ea > 1 ? ` X ${orderGoods.ea}` : ''
                  }`}</MoDetailTxt>
                  <MoDetailPrice>
                    {getComma(orderGoods?.salePrice * orderGoods?.ea)}원
                  </MoDetailPrice>
                </MoDetailBtwBox>
                {orderGoods?.optionList &&
                  orderGoods?.optionList.length > 0 &&
                  orderGoods?.optionList.map(
                    (option, k) =>
                      option?.optionGoodsList &&
                      option?.optionGoodsList?.map((item, i) => (
                        <>
                          <MoDetailBtwBox className="ms-2" key={k}>
                            <MoDetailAddTxt>{`${item?.goodsName ?? ''}${
                              item.ea > 1 ? ` X ${item?.ea}` : ''
                            }`}</MoDetailAddTxt>
                            <MoDetailAddPrice>
                              {getComma(item?.salePrice * item?.ea)}원
                            </MoDetailAddPrice>
                          </MoDetailBtwBox>
                        </>
                      )),
                  )}
                {/* {orderGoods.optionList &&
                  orderGoods.optionList.length > 0 &&
                  orderGoods.optionList[i]?.optionGoodsList?.map(
                    (option, k) => (
                      <MoDetailBtwBox key={k}>
                        <MoDetailAddTxt>{option.goodsName}</MoDetailAddTxt>
                        <MoDetailAddPrice>
                          {getComma(option.salePrice)}원
                        </MoDetailAddPrice>
                      </MoDetailBtwBox>
                    ),
                  )} */}
              </>
            )
          })}
          <MoDetailBtwBox className="borderLineBold">
            <MoDetailTxt>총 결제금액</MoDetailTxt>
            <MoDetailPrice>{getComma(orderList?.orderMoney)}원</MoDetailPrice>
          </MoDetailBtwBox>
        </MoDetailBox>
      </MoDetailWrap>
      {orderCancelled ? (
        <MoDetailWrap>
          <MoDetailBoxTit>결제정보</MoDetailBoxTit>
          <MoDetailBox>
            <MoDetailBtwBox marginBottom={'0'}>
              <MoDetailTxt>취소</MoDetailTxt>
              <MoDetailPrice>{orderList?.CancelReason ?? ''}</MoDetailPrice>
            </MoDetailBtwBox>
          </MoDetailBox>
        </MoDetailWrap>
      ) : (
        <MoDetailWrap>
          <MoDetailBoxTit>정산정보</MoDetailBoxTit>
          <MoDetailBox>
            <MoDetailBtwBox>
              <MoDetailTxt>판매금액</MoDetailTxt>
              <MoDetailPrice>{getComma(orderList?.orderMoney)}원</MoDetailPrice>
            </MoDetailBtwBox>
            {!isPickup && (
              <MoDetailBtwBox>
                <MoDetailTxt>배달료</MoDetailTxt>
                <MoDetailPrice>
                  {getComma(orderList?.deliveryFee)}원
                </MoDetailPrice>
              </MoDetailBtwBox>
            )}

            <MoDetailBtwBox className="borderLineBold">
              <MoDetailTxt>정산금액</MoDetailTxt>
              <MoDetailPrice>
                {getComma(
                  parseInt(orderList?.payMoney),
                  // +
                  //   parseInt(orderList.deliveryFee),
                )}
                원
              </MoDetailPrice>
            </MoDetailBtwBox>
          </MoDetailBox>
        </MoDetailWrap>
      )}
      {orderTypeDelivery && (
        <MoDetailWrap>
          <MoDetailBoxTit>배달정보</MoDetailBoxTit>
          <MoDetailBox>
            <MoDetailPrice>{orderList?.address1 ?? ''}</MoDetailPrice>
            {isDeliveryVisible && (
              <MoDetailAddress>
                <span>
                  {!hiddenOrder.includes(orderList?.ReceiptId)
                    ? orderList?.address2 ?? ''
                    : '*****'}
                </span>
                <span>
                  {!hiddenOrder.includes(orderList?.ReceiptId)
                    ? orderList?.receiverHp ?? ''
                    : '*****'}
                </span>
              </MoDetailAddress>
            )}
            {/* {!isComplete && ( */}
            <AddressDetailBtn>
              <button
                className="addressBtn"
                type="button"
                onClick={() =>
                  handleToggleDelivery(orderList, isDeliveryVisible)
                }
              >
                {isDeliveryVisible ? '상세정보 숨기기' : '상세정보 확인하기'}
              </button>
            </AddressDetailBtn>
            {/* )} */}
          </MoDetailBox>
        </MoDetailWrap>
      )}
    </>
  )
}

export default MoDetailItem

const MoDetailWrap = styled.article`
  width: 100%;
  padding: 28px 20px;
  background-color: #f3f3f3;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  margin-top: 5px;
`
const MoDetailBox = styled.div`
  display: flex;
  flex-direction: column;
  ${(props) => props.orderCancelled && 'opacity: 0.3;'}

  .borderLine {
    border-bottom: 1px solid #e5e5e5;
    padding-bottom: 15px;
  }
  .borderLineBold {
    border-top: 1px solid #000;
    padding-top: 15px;
  }
`

const MoDetailBtwBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* margin-bottom: 15px;  */
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom + 'px' : '15px'};
`

const MoDetailBoxTit = styled.h4`
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: #000;
  padding-bottom: 15px;
  margin-bottom: 18px;
  border-bottom: 1px solid #e5e5e5;
`

const AddressDetailBtn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  width: 160px;
  height: 25px;
  margin: 10px 0;
  .addressBtn {
    background-color: ${colors.mainG};
    color: #fff;
    border-radius: 7px;
    width: 100%;
    height: 100%;
  }
`

const MoDetailTxt = styled.h4`
  font-size: 14px;
  color: #000;
`
const MoDetailPrice = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: #000;
`
const MoDetailAddTxt = styled.h4`
  font-size: 13px;
  color: #8a8a8a;
`
const MoDetailAddPrice = styled.p`
  font-size: 13px;
  color: #000;
`

const MoDetailAddress = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #000;

  span {
    margin-top: 10px;
  }
`
